import { render } from "./modalCoachBookVideo.vue?vue&type=template&id=60f600ce&scoped=true"
import script from "./modalCoachBookVideo.vue?vue&type=script&lang=js"
export * from "./modalCoachBookVideo.vue?vue&type=script&lang=js"

import "./modalCoachBookVideo.vue?vue&type=style&index=0&id=60f600ce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f600ce"]])

export default __exports__